angular.module("pe4h").factory("AuthService",[
	"$rootScope",
	"localStorageService",
    "$timeout",
	function ($rootScope, localStorageService, $timeout) {
		
		var _AUTHJWTKEY = "storage.auth.token";
                                		
		var authService = {};
		
		var _saveJWT = function(data){
		    localStorageService.set(_AUTHJWTKEY, data);		    
		};
		var _deleteJWT = function(){
		    localStorageService.remove(_AUTHJWTKEY);		    
		};
		var _getJWT = function(){
		    return localStorageService.get(_AUTHJWTKEY);		    
		};
		
		authService.save = _saveJWT;
		authService.delete = _deleteJWT;
		authService.get = _getJWT;
		
		return authService;	
	}
]);